module.exports = __webpack_public_path__ + "static/media/cuhk.b4fcce24.png";